<template>
  <div class="page">
    <!-- 环卫运营 -->
    <div class="nav_top"></div>
    <navigation-bar2 />
    <div class="swiperModel">
      <div v-for="(item, index) in lunboImgs" :key="index">
        <img :src="imgUrl + item.img" alt="" />
      </div>
    </div>

    <div class="options">
      <div @click="clickOption(1)">环卫服务经典案例</div>
      <div @click="clickOption(2)">环卫设备经典案例</div>
    </div>
    <div class="list">
      <div class="list_item" v-for="(item, index) in huanweiOperation" :key="index" @click="viewDetails(item)">
        <img :src="imgUrl + item.homePageImg" alt="" @click="viewImg" />
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="800px">
      <el-carousel height="350px">
        <el-carousel-item v-for="(item, index) in detailLunboImg" :key="index + '1'">
          <img v-lazy="imgUrl + item.img" alt="" />
        </el-carousel-item>
      </el-carousel>
      <div>
        <p class="title">{{ detailTitle }}</p>
        <p class="text">
          {{ content }}
        </p>
      </div>
    </el-dialog>
    <bottom-area />
  </div>
</template>

<script>
export default {
  name: "",
  created() {
    this.anliID = this.$route.query.anliID;
    // if (this.anliID) {
    //   this.dialogVisible = true;
    // }
    this.getData();
  },
  data() {
    return {
      anliID: "",
      dialogVisible: false,
      imgUrl: this.$store.state.imgUrl,
      lunboImgs: [],
      huanweiOperation: [],
      detailLunboImg: [],
      detailTitle: "",
      content: "",
      detailParagraph: "",
      type: 1,
    };
  },
  components: {
    NavigationBar2: () => import("../views/nav/NavigationBar2"),
    SwiperPage2: () => import("../views/swiper/SwiperPage2"),
    serchProduct: () => import("../views/searchProduct/serchProduct"),
    BrandProducts: () => import("../views/BrandProducts/BrandProducts"),
    ProductList: () => import("../views/ProductList/ProductList"),
    BottomArea: () => import("../views/footer/BottomArea"),
  },
  methods: {
    viewImg() {
      this.dialogVisible = true;
    },
    clickOption(type) {
      this.type = type;
      this.getData();
    },
    async getData() {
      const { data: res } = await this.$http.get("/huanweiOperation/list", {
        params: {
          type: this.type,
        },
      });
      console.log(res);
      this.lunboImgs = res.result.lunboImgs;
      this.huanweiOperation = res.result.huanweiOperation;
    },
    viewDetails(val) {
      console.log(val);
      this.detailLunboImg = val.imgs;
      this.detailTitle = val.title;
      this.content = val.content;
      // this.detailLunboImg = val.imgs;
    },
  },
};
</script>

<style scoped lang="less">
.nav_top {
  width: 100%;
  height: 15px;
  background-color: #19344a;
  color: #ffffff;
}
.swiperModel {
  width: 100%;
  height: 680px;
}
.el-dialog {
  .el-carousel {
    width: 700px;
    margin: 0 auto;
  }
  div {
    width: 700px;
    margin: 0 auto;
    .title {
      font-size: 22px;
      width: 100%;
      text-align: center;
      font-weight: 700;
      margin: 20px 0;
      letter-spacing: 5px;
    }
    .text {
      color: #666666;
      letter-spacing: 2px;
      text-align: center;
      font-size: 12px;
    }
  }
}
.options {
  display: flex;
  justify-content: space-between;
  div {
    width: 50%;
    height: 150px;
    line-height: 150px;
    text-align: center;
    background-color: #f0f1f3;
    font-size: 30px;
    font-weight: 400;
    letter-spacing: 5px;
  }
}
.list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 150px;
  box-sizing: border-box;
  margin-top: 30px;

  .list_item {
    max-width: 33%;
    box-sizing: border-box;
    margin-bottom: 20px;
    float: left;
    height: 600px;
    background-color: #f0f1f3;
    box-sizing: border-box;
    img {
      width: 100%;
    }
  }

  .list_item:hover {
    box-shadow: 0px 0px 20px #cccccc;
    transition: 0.5s;
    border-radius: 5px;
  }
}
.list:after {
  content: "";
  width: 33%;
}
</style>
